// extracted by mini-css-extract-plugin
export default {"our_professionals":"OurProfessionals_our_professionals__ex6PN","professionals_img":"OurProfessionals_professionals_img__1aL27","carousel":"OurProfessionals_carousel__tY5m7"};